<template>
  <main id="event_body">
    <top-menu :top_title="top_title"></top-menu>
    <div class="div_padding"></div>
    <div class="wrapper">
      <div class="main_text_box">
        <h3>혜택이 <span id="thehae">더해</span>지는 찬스,</h3>
        <h3>이벤트 참여하고 <span id="thehae">더해</span>봐요.</h3>
        <div class="" style="height:32px"></div>
      </div>
    </div>
    <div class="myPost_wrapper" id="more_board">
       <!-- list -->
      <div class="list_div">

        <div class="post_list">
          <!-- LOTTO -->
          <!-- :class="event.status == 'END' ? 'end' : ''" -->
          <div class="event" @click="goToLottoDetail(newEvent.eventId)" v-for="newEvent in newEventList" :key="newEvent.eventId">
            <div class="event_img">
              <img :src="newEvent.imageUrl" alt="" loading="lazy">
            </div>
            <div class="text">
              <span class="date">{{newEvent.eventTitle}}</span>
              <div class="title">
                <p v-html="newEvent.listText.replace(/(?:\r\n|\r|\n)/g,'</br>')"></p>
              </div>
            </div>
          </div>
          <!-- EVENT -->
          <div class="event" @click="goToEventDetail(event.nttId, event.status)" v-for="event in eventList" :key="event.nttId" :class="event.status == 'END' ? 'end' : ''">
            <div class="event_img">
              <img :src="event.eventImageUrl" alt="" loading="lazy" :style="event.status == 'END' ? 'filter: brightness(0.7);':''">
            </div>
            <div class="text">
              <span class="date">{{ event.eventDate }}</span>
              <div class="title">
                <p>{{ event.eventTitle }}</p>
                <p v-html="event.eventText"></p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <bottom-menu></bottom-menu>
  </main>  
</template>

<script>
import TopMenu from '@/components/common/TopMenu';
import BottomMenu from '@/components/common/BottomMenu';
import { fetchEventList } from '@/api/event'
export default {
  components: {
    TopMenu,
    BottomMenu
  },
  created() {
    window.VueRoot=this;
    fetchEventList({
      pageIndex: this.pageIndex,
      recordCntOnPage: 10,
    })
    .then(({ data }) => {
      this.newEventList = data.newEvent;
      this.eventCnt = data.resultCnt;
      this.eventList = data.resultList
    })
  },
  data() {
    return {
      top_title: '<span id="top_title">이벤트</span>',
      pageIndex: 1,
      eventCnt: 0,
      eventList: [],
      newEventList:[]
    }
  },
  mounted() {
     document.getElementById( 'icon_event' ).src = 'images/basic/menu_icon/icon-tabbar-event-on.svg';
      window.addEventListener('scroll', () => { // scroll event 등록
        if(window.$(window).scrollTop() == window.$(document).height() - window.$(window).height()){
            this.fetchData();
        }
    });

    const offset = 10;
    window.addEventListener("scroll", () => {
      // scroll event 등록
      if(window.$(window).scrollTop() > (window.$(document).height() - window.$(window).height()) - offset){
        this.fetchData();
      }
    });

  },
  methods: {
    goToEventDetail(nttId, status) {
      if(status == "READY") {
        this.$router.push({
          path: '/upcomingEvent', query: { nttId }
        })
      }
      if(status == "ING") {
        this.$router.push({
          path: '/ongoingEvent', query: { nttId }
        })
      }
      if(status == "END") {
        this.$router.push({
          path: '/endedEvent', query: { nttId }
        })
      }
    },
    fetchData() {
      if(this.eventList.length < this.eventCnt) {
        this.pageIndex += 1
        fetchEventList({
          pageIndex: this.pageIndex,
          recordCntOnPage: 10
        })
        .then(({ data }) => {
          this.eventCnt = data.resultCnt;
          this.eventList = [...this.eventList, ...data.resultList];
        })
      }
    },
    goToLottoDetail(eventId) {
      this.$router.push({
        path: '/ongoingLotto', query: { eventId:eventId }
      })
    },
  },
}
</script>

<style scoped>
#more_board {
  padding-bottom: calc(var(--bottom) + var(--safebottomenv));
}
.myPost_wrapper .post_list p {
  font-size: 14px;
}
</style>